export default "__VITE_ASSET__CtEUujz5__"